module.exports = __webpack_public_path__ + "img/glasses-2.32495321.svg";